<template>
  <div v-show="displayExplanationRef" :class="$style.e_gift_annotation">
    <h3 :class="$style.title">eギフトとは？</h3>
    <div :class="$style.service">
      <p :class="$style.headline">■ どんなサービス？</p>
      <p :class="$style.explanation">
        相手の住所を知らなくても、LINEやSNSなどで受け取りURLを送ることでギフトを相手に贈れるサービスです。カラー・サイズは受け取り手に選んでもらえます。
        購入後に発行される、eギフト受け取りURLをお相手の方にLINEやSNSでお送りすることができます。お相手の方は会員登録不要で、住所と商品情報を入力すると商品が届きます。
      </p>
      <p :class="$style.note">
        ※ 通常購入とeギフトで贈る商品を同時に購入できません。<br />
        ※ eギフトと刺繍サービスを併用で設定する事はできません。<br />
        ※ 予約販売の商品はeギフトで受け取り時に選択ができない商品となります。<br />
        ※
        eギフトをご注文いただいてもラッピング資材は付いておりません。ラッピングをご希望の場合は、商品購入時に予めギフトラッピングを設定の上ご注文をお願いいたします。<br />
        ※
        注文1件につき贈り先は1つとなります。複数贈り先がある場合にはお手数おかけ致しますが、1件ずつご注文をお願いいたします。<br />
        ※ 発行されたURLの受け取り期限は購入より5日後です。<br />
        ※
        受け取りURLの期限（購入後5日後）が過ぎた場合、注文者様の方で受け取り手続きを行う又は、注文をキャンセルいただくことが可能です。
      </p>
    </div>
    <div :class="$style.service">
      <p :class="$style.headline">■ 送り主名について</p>
      <p :class="$style.explanation">
        eギフト設定時には「贈り主名」の入力が必須となっておりますが、本名ではなくニックネームでも設定可能なため、本名を明かさずに贈ることが可能です。
      </p>
      <p :class="$style.explanation">
        お届けする荷物の配送伝票（送り状）にご注文者様のお名前は記載されず、「依頼主:株式会社TENTIAL」と記載された状態でお届けとなります。
      </p>
    </div>
    <div :class="$style.service">
      <p :class="$style.headline">■ メッセージについて</p>
      <p :class="$style.explanation">
        ご入力頂くメッセージはWEB上でのみ表示される仕様となり、ギフト内に紙面に印刷されたメッセージなどは同封されません。
      </p>
    </div>
    <div :class="$style.flow">
      <p :class="$style.headline">■ ご注文から受け取りまでの流れ</p>
      <div v-for="(content, _index) in eGiftContents" :key="content.title" :class="$style.contents">
        <p :class="$style.num">{{ _index + 1 }}</p>
        <p>{{ content.title }}</p>
        <!-- <AtomsConsumerImage :src="content.img" :class="$style.img" /> -->
      </div>
    </div>
    <AtomsConsumerButton variant="secondary" block @click="eGiftContentsClose">閉じる</AtomsConsumerButton>
  </div>
</template>

<script setup lang="ts">
type Props = {
  displayExplanationRef: boolean
}

type Emit = {
  (e: "eGiftContentsClose"): void
}

withDefaults(defineProps<Props>(), {
  displayExplanationRef: false,
})

const eGiftContents = [
  {
    img: "/images/common/cart/e-gift-contents1.png",
    bar: "/images/common/cart/e-gift-contents1-bar.svg",
    title: "eギフトとして贈りたい商品を、選択して購入します",
  },
  {
    img: "/images/common/cart/e-gift-contents2.png",
    bar: "/images/common/cart/e-gift-contents2-bar.svg",
    title: "購入後に購入者様宛に届くメールから、受け取りURLをコピーします",
  },
  {
    img: "/images/common/cart/e-gift-contents3.png",
    bar: "/images/common/cart/e-gift-contents3-bar.svg",
    title: "受け取りURLを家族や友人など、届けたい相手に送ります",
  },
  {
    img: "/images/common/cart/e-gift-contents4.png",
    bar: "/images/common/cart/e-gift-contents4-bar.svg",
    title: "お相手の方が住所と商品情報を入力すると、ギフトとして商品が届きます",
  },
]

const emit = defineEmits<Emit>()

const eGiftContentsClose = (): void => {
  emit("eGiftContentsClose")
}
</script>

<style module scoped lang="scss">
.e_gift_annotation {
  max-width: $max-width-md;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  .service {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .headline {
    font-size: $font-size-16;
    font-weight: bold;
  }
  .note {
    @include sub-font;
    font-size: $font-size-14;
    color: $danger;
  }
  .explanation {
    @include sub-font;
    font-size: $font-size-14;
  }
  .flow {
    display: flex;
    flex-direction: column;
    .contents {
      display: flex;
      gap: 1rem;
      align-items: center;
      .img {
        width: 75%;
        max-width: 200px;
      }
      .num {
        @include main-font;
        font-size: $font-size-20;
      }
      .head {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        text-align: center;
        p {
          @include sub-font;
          font-size: $font-size-16;
        }
      }
    }
  }
}
</style>
